import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/footer").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const y = new Date().getFullYear();
  if (!data) return null;

  return (
    <footer className="px-6 md:px-12 lg:px-24 pb-12 pt-20 border-t border-neutral-300" data-testid="site-footer">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
        <div className="md:col-span-6">
          <p className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-none">
            {data.studio_name}<span className="text-[#FF3E00]">®</span>
          </p>
          {data.blurb && <p className="font-body text-sm text-neutral-600 mt-4 max-w-md">{data.blurb}</p>}
        </div>
        {data.social_links?.length > 0 && (
          <div className="md:col-span-3 md:col-start-8">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Elsewhere</p>
            <ul className="space-y-2 font-body text-sm">
              {data.social_links.map((s, i) => (
                <li key={i}>
                  <a href={s.url} className="link-line" data-testid={`social-${s.label.toLowerCase()}`}>{s.label}</a>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="md:col-span-3">
          <p className="font-body text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">Contact</p>
          <ul className="space-y-2 font-body text-sm">
            {data.email && <li>{data.email}</li>}
            {data.phone && <li>{data.phone}</li>}
            {data.address && <li>{data.address}</li>}
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col md:flex-row justify-between gap-4 border-t border-neutral-300 pt-6 font-body text-xs uppercase tracking-[0.2em] text-neutral-500">
        <span>© {y} {data.studio_name} — All rights reserved</span>
        {data.tagline_right && <span>{data.tagline_right}</span>}
      </div>
    </footer>
  );
}
